import { getStartedSearchSchema } from '@routes/_authenticated/_layout/workspaces/$subscriptionId/get-started/index'
import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { GetStartedPage } from 'features/getStarted'
import { canViewAnalyticsPermission, canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/get-started/$stepSlug')({
  component: GetStartedPage,
  validateSearch: getStartedSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Get Started'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)
    await protectWithWorkspacePermissions(canViewConfigurationPermission)(ctx)
  },
})
